import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import BalanceSheetPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/BalanceSheetPicker';
import {
  useSummarySidebarContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import RefinanceDebtSectionPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/BalanceSheetPicker/BalanceTransferRollover/Content/RefinanceDebtSectionPicker';
import { FDStack } from '@facet-wealth/design';
import BalanceTransferRolloverSectionPicker from './BalanceTransferRolloverSectionPicker';
import { useBalanceTransferRolloverContext } from '../Context';

const useStyles = buildUseStyles('BalanceTransferRollover', (() => ({
  root: {
    overflowX: 'hidden',
  },
})));

const BalanceTransfer = () => {
  const { facetPlanInputCollection } = useSummarySidebarContentContext();


  const {
    balanceTransferResource,
    handleAddBalanceTransfer,
    handleModifyBalanceTransfer,
    handleAddRefinanceDebt,
    handleModifyRefinanceDebt,
  } = useBalanceTransferRolloverContext();

  const classes = useStyles();

  return (
    <Box padding={2} className={classes.root}>
      <FDStack spacing={2} direction="column">
        <BalanceSheetPicker balanceSheetCollection={facetPlanInputCollection?.attr('facetPlanBalanceSheetCollection')} />
        <BalanceTransferRolloverSectionPicker
          balanceTransferResource={balanceTransferResource}
          handleAddBalanceTransfer={handleAddBalanceTransfer}
          handleModifyBalanceTransfer={handleModifyBalanceTransfer}
        />
        <BalanceTransferRolloverSectionPicker
          balanceTransferResource={balanceTransferResource}
          title={'Generated Money Movements'}
          itemCollection={facetPlanInputCollection?.attr('generatedMoneyMovements')}
          handleModifyBalanceTransfer={handleModifyBalanceTransfer}
          showResetButton={false}
        />
        <RefinanceDebtSectionPicker
          resource={balanceTransferResource}
          handleAddRefinanceDebt={handleAddRefinanceDebt}
          handleModifyRefinanceDebt={handleModifyRefinanceDebt}
        />
      </FDStack>
    </Box>
  );
};

export default BalanceTransfer;
